/**
 * 加载 public/ivan-sync 下从 Ivan 抓取的只读对照数据。
 */
export function ivanSyncUrl(name) {
  const base = process.env.BASE_URL || '/'
  const file = String(name || '').replace(/^\//, '')
  return `${base}ivan-sync/${file}`
}

export async function loadIvanSyncJson(name) {
  const res = await fetch(ivanSyncUrl(name), { cache: 'no-store' })
  if (!res.ok) throw new Error(`加载 ${name} 失败: ${res.status}`)
  return res.json()
}
